import React from 'react';
import { BrainGraph } from '../components/deck/BrainGraph';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
const uses = ['Enterprise sales', 'Product & AI engineering', 'Data infrastructure', 'Customer expansion', 'Go-to-market'];
export function FundraiseSlide() {
  return <Slide variant="deep" data-id="element-92" data-mp="1csh9hx2yhmxg">
      <div className="grid min-h-0 flex-1 grid-cols-[56%_1fr] gap-[3cqw]" data-id="element-93" data-mp="29gwyns25lua1">
        <div className="flex min-h-0 flex-col" data-id="element-94" data-mp="25es7r133bbr3">
          <Eyebrow data-id="element-95" data-mp="25g3bx20g6liq">The raise</Eyebrow>
          <Title className="mt-[2.2cqh] max-w-[92%]" data-id="element-96" data-mp="25h6217py4jxl">The Intelligence Layer for Private Markets.</Title>

          <div className="mt-[3.4cqh] flex items-baseline gap-[1.4cqw]" data-id="element-97" data-mp="20lqsut2vvc7i">
            <p className="text-[clamp(38px,4.8cqw,102px)] leading-none text-[#F4F7FC]" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-98" data-mp="1voqjo9aqltc6">
              $2M
            </p>
            <span className="text-[clamp(9px,0.94cqw,20px)] uppercase tracking-[0.24em] text-[#3B8CFF]" data-id="element-99" data-mp="2obl1szk30gmh">
              Raising
            </span>
          </div>

          <Reveal delay={0.16} className="mt-auto border-t border-white/12 pt-[2.4cqh]" data-id="element-100" data-mp="2twfb2y5de0lx">
            <p className="text-[clamp(18px,2.1cqw,44px)] leading-tight text-[#F4F7FC]" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-101" data-mp="2g6vanyz9hffs">
              More Accurate. More Private. More Cost-Efficient.
            </p>
            <Caption className="mt-[1.4cqh]" data-id="element-102" data-mp="269yynja5mb6h">DiligenceGPT™ by StartupFuel</Caption>
            <p className="mt-[2cqh] text-[clamp(10px,1.05cqw,22px)] text-[#C3CBD9]" data-id="element-103" data-mp="2b8aau0nx8xrv">
              Ashley “Ash” Martis · Founder &amp; CEO ·{' '}
              <span className="text-[#3B8CFF]" data-id="element-104" data-mp="2189nm3mxlxie">startupfuel.com</span> ·{' '}
              <span className="text-[#3B8CFF]" data-id="element-105" data-mp="21amcl0r3x84y">dgpt.io</span>
            </p>
          </Reveal>
        </div>

        <div className="relative flex min-h-0 flex-col" data-id="element-106" data-mp="3vmu21yknswtc">
          <span className="text-[clamp(8px,0.82cqw,17px)] uppercase tracking-[0.22em] text-[#2FBE8F]" data-id="element-107" data-mp="3vmao0sy4qskl">
            Use of funds
          </span>
          <ul className="mt-[2.2cqh] space-y-[1.6cqh]" data-id="element-108" data-mp="13fjtctekiuxh">
            {uses.map((use, i) => <Reveal key={use} delay={0.06 * i} className="border-b border-white/8 pb-[1.6cqh] text-[clamp(11px,1.25cqw,26px)] text-[#DCE3EE]" data-id="element-109" data-mp="zdoppi9605gj" data-mpi={i}>
                {use}
              </Reveal>)}
          </ul>
          <BrainGraph density={1} className="pointer-events-none absolute -right-[3cqw] bottom-[-4cqh] h-[22cqh] w-auto opacity-40" data-id="element-110" data-mp="1r6p7n44v1f5o" />
        </div>
      </div>
    </Slide>;
}